// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"ef1aeef3","453":"04af9047","503":"3d6901c9","783":"5407739a","881":"0d994a14"}[chunkId] + ".chunk.js";
};